<template>
   <div v-if="!loading">
    <v-btn color="primary" @click="addAssesment()"><v-icon>mdi-plus</v-icon>Einschätzung</v-btn>
    <v-row>
      <v-col cols="4"></v-col>
      <v-col v-for="assessment in assessments" :key="assessment.name">
        {{timeConverter(assessment.timestamp)}}
        <v-textarea
          :disabled="assessment.id != -1"
          name="input-7-1"
          label="Beschreibung"
          v-model="assessment.description"
        ></v-textarea>
      </v-col>
    </v-row>
    <div v-for="charType in roleCharacteristicTypes" :key="charType">
        <p>{{charType}}</p>
        <hr />
        <v-row >
            <v-list-item v-for="desc in roleDescriptors[charType]" :key="desc.id">
              <v-col cols="4">{{desc.name == null ? desc:desc.name}}</v-col>
              <v-col v-for="assessment in assessments" :key="assessment.id">
                <v-select
                  :disabled="assessment.id != -1"
                  :items="selectOptions"
                  item-text="name"
                  item-value="value"
                  :value="getAssessmentValue(assessment, desc)"
                  @change="updateAssessmentValue($event, assessment, desc)"
                  solo
                ></v-select>

              </v-col>
                </v-list-item>
               <v-col cols="4">

                <v-text-field v-model="newDesc[charType]"></v-text-field>
                    <v-btn color="primary" @click="addDescriptor(charType)"><v-icon>mdi-plus</v-icon></v-btn>
               </v-col>
        </v-row>
    </div>
   </div>
  </template>
  
  <script>
  import connectedRessourceService from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
import { connected } from 'process';
  export default {
    name: "RessourcesDialog",
    props: ['roleDescriptors', 'roleId'],
    data() {
      return {
       roleCharacteristicTypes: null,
       assessments:[],
       loading: true,
       newDesc: {
        TASKS: "",
        POWERS:"",
        RESPONSIBILITIES:"",
        HARDSKILLS:"",
        SOFTSKILLS:""
       },
       selectOptions:[
        {name: "Gut", value: "HIGH"},
        {name: "Mittel", value: "MEDIUM"},
        {name: "Schlecht", value: "LOW"}
       ]
      }
    },
    watch:{
      roleDescriptors(){
        this.roleCharacteristicTypes = Object.keys(this.roleDescriptors);
        if(this.roleId != null){
          connectedRessourceService.getRoleCharacteristicAssessment(this.roleId).then(result => {
            this.assessments = result.data;
            //this.loading = false;
          })
        }
      },
      assessments: {
        handler: function(){
          
        },
        deep:true
      }
    },
    computed:{
      
    },
    mounted(){
      this.roleCharacteristicTypes = Object.keys(this.roleDescriptors);
        if(this.roleId != null){
          connectedRessourceService.getRoleCharacteristicAssessment(this.roleId).then(result => {
            this.assessments = result.data;
            this.loading = false;
          })
        }
    },
    methods: {
      timeConverter(timestamp) {
        let dt = new Date(timestamp);
        let months = ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Oct','Nov','Dez'];
        let year = dt.getFullYear();
        let month = months[dt.getMonth()];
        let date = dt.getDate();
        let time = month + ' ' + date + '. ' + year;
        return time
      },
      getAssessmentValue(assessment, desc){
        if(desc.id == -1){
          return assessment.assessmentValues.find(elem => elem.roleDescriptor.name == desc.name);
        }else{
          let assessmentVal = assessment.assessmentValues.find(elem => elem.roleDescriptor.id == desc.id);
          if(assessmentVal == null) return null;
          let val = this.selectOptions.find(option => option.value == assessmentVal.assessmentValue);
          
          if(val == null){
            return assessment.assessmentValues.find(elem => elem.roleDescriptor.name == desc.name);
          }else{
            return val;
          }
        }        
      },
      addDescriptor(type){
        this.roleDescriptors[type].push({
          id: -1,
          type: type,
          name: this.newDesc[type]
        });
        this.newDesc[type] = "";
        this.$emit("updateDescriptor", this.roleDescriptors);
      },
      updateAssessmentValue(data, assessment, descriptor){
        if(assessment.assessmentValues == null) assessment.assessmentValues = [];
        let val = null;
        if(descriptor.id == -1){
          val = assessment.assessmentValues.find(elem => elem.roleDescriptor.name == descriptor.name);
        }else{
          val = assessment.assessmentValues.find(elem => elem.roleDescriptor.id == descriptor.id);
        }
        if(val == null){
          assessment.assessmentValues.push({
            roleDescriptor: {
              name: descriptor.name
            },
            assessmentValue: data,
            id: -1
          })
        }else{
          val.assessmentValue = data;
        }
        this.$emit("assessmentsChanged", assessment);
      },
      addAssesment(){
        let assessmentValues = [];
        for(let key in this.roleDescriptors){
          this.roleDescriptors[key].forEach(elem => {
            assessmentValues.push({
              id: -1,
              roleDescriptor: elem,
              assessmentValue: null
            })
          })
          
        }
        let assessment = {
          id: -1,
          timestamp: new Date(),
          assessmentValues: assessmentValues,
          description: null
        }
        this.assessments.push(assessment);
        this.$emit("assessmentsChanged", assessment);
      }
    }
  };
  </script>
  
  <style>
  .dialog {
    flex-grow: 0;
    padding: 20px;
    background-color: #fff;
  }
  
  .header{
    width: 100%;
    height: 50px;
    margin: 0px;
  }
  .description{
    display:inline-block;
    width: calc(60% - 5px);
    height: 400px;
    margin: 15px 5px 0 0;
  }
  .modelList{
    display:inline-block;
    width: calc(40% - 15px);
    height: 400px;
    margin: 5px 0 0 15px;
    border-left: 2px solid var(--v-primary-base);
  }
  .elementDivider{
  
    margin: 1px;
    border: 0.5px solid var(--v-primary-base);
  }
  </style>